/**
 * 3-candle fair value gaps. Same geometry as FairValueGapPrimitive:
 * bullish when low(c3) > high(c1); bearish when high(c3) < low(c1).
 */
export function fairValueGapAt(bars, i, { minSize = 0, maxSize = Infinity } = {}) {
  if (!bars || i < 2) return null;
  const c1 = bars[i - 2];
  const c2 = bars[i - 1];
  const c3 = bars[i];
  if (!c1 || !c2 || !c3) return null;

  const bullish = c3.low > c1.high;
  const bearish = c3.high < c1.low;
  if (!bullish && !bearish) return null;

  const top = bullish ? c3.low : c1.low;
  const bottom = bullish ? c1.high : c3.high;
  const size = top - bottom;
  if (!(size > minSize && size < maxSize)) return null;

  return {
    direction: bullish ? 'Long' : 'Short',
    top,
    bottom,
    size,
    startIndex: i - 2,
    midIndex: i - 1,
    endIndex: i,
    time: c3.timestamp,
  };
}

export function fairValueGaps(bars, params = {}) {
  const out = new Array((bars || []).length).fill(null);
  for (let i = 2; i < (bars || []).length; i++) {
    out[i] = fairValueGapAt(bars, i, params);
  }
  return out;
}
